module.exports = require('./helpers/bundle-url').getBundleURL('1DydH') + "logo-dark.eefe0b7f.svg";